module.exports = __webpack_public_path__ + "static/trusted-by-2-rows-6dd4bcd97d401ad412305c35b66f70b2.png";